import { FormikProvider, useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { useCreateFormMutation } from '@/modules/admin-dashboard/queries/forms.ts';
import { adminDashboardPaths } from '@/modules/admin-dashboard/routes.tsx';
import { BaseModalProps, Button, ModalContentWrapper, TextInputField } from 'ui';

export interface CreateFormModalProps extends BaseModalProps {
  tag_ids?: number[];
}

const validationSchema = yup.object({
  name: yup.string().max(100).required('Please write some name'),
});

const initialValues = {
  name: '',
  data: [],
};

export const CreateFormModal = ({ open, tag_ids, onClose }: CreateFormModalProps) => {
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: { ...initialValues, tag_ids },
    validateOnBlur: false,
    validateOnChange: false,
    validateOnMount: false,
    validationSchema,
    onSubmit: async values => {
      const form = await createForm(values);

      onClose();

      if (form.form.id) {
        navigate(
          {
            pathname: adminDashboardPaths.dynamic.form(form.form.id),
            search: location.search,
          },
          {
            replace: false,
          },
        );
      }
    },
  });

  const { mutateAsync: createForm, isLoading } = useCreateFormMutation(formik.setErrors);

  return (
    <ModalContentWrapper open={open} title="Add new form" onClose={onClose}>
      <FormikProvider value={formik}>
        <form className="w-full flex flex-col items-center gap-4" onClick={e => e.preventDefault()}>
          <TextInputField name="name" label="form name" placeholder="Some name..." />
          <Button type="submit" onClick={formik.submitForm} disabled={isLoading}>
            Create form
          </Button>
        </form>
      </FormikProvider>
    </ModalContentWrapper>
  );
};
